<template>
  <div v-if="iconSrc" class="mr-0 pull-left my-incident-icon-container">
    <img
      :src="iconSrc"
      :height="iconSize"
      :width="iconSize"
      class="my-incident-icon"
      alt="My Incident"
    />
  </div>
</template>

<script>
export default {
  name: "MyIncidentIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 25,
    },
  },
  computed: {
    iconSrc() {
      if (this.icon) {
        return require(`@/assets/images/icons/myIncidents/${this.icon}.png`);
      }
      return null;
    },
  },
};
</script>

<style scoped>
.my-incident-icon-container {
  border-radius: 20px;
  position: relative;
}
.my-incident-icon {
  margin: 0;
  position: relative;
}
</style>
